var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.confirmSyncStatus}},[_vm._v("確認する")])}
var staticRenderFns = []

export { render, staticRenderFns }